
// Este archivo contiene todas las constantes de diseño:

export const colors = {
  // Text colors
  textPrimary: "#FFFFFFD9",
  textSecondary: "#7F8185",
  textTertiary: "#999", 
  textDark: "#292D33",
  // Map panel header (Titulos y descripciones: text/primary + descripción panel)
  textPanelTitle: "#D4D4D4",
  textPanelDescription: "#FFFFFF",
  
  // Brand colors
  primary: "#489291",
  primaryHover: "#3A7877",
  primaryLight: "#5AA5A4",

  // Border colors
  border: "#4A4A4A",
  
  // Background colors
  backgroundDark: "#242424",
  backgroundLight: "#FFFFFF",
  backgroundGray: "#F0F0F0",
  backgroundSurface: "#1C1C1C",
  // Overlay inicial de páginas compartidas / lista (antes de montar el mapa)
  pageBootBackground: "#0F0F0F",
  // Buildings 3D en share CAD (crema / gris cálido; no el acento)
  buildingNeutral: "#C9C8C2",
  // Plazas / áreas naturales CAD (70, 119, 50). No es el success de UI.
  naturalGreen: "#467732",
  
  // Input colors
  inputBg: "#FFFFFF",
  inputBorder: "#00000026",
  
  // State colors
  disabled: "#E0E0E0",
  disabledText: "#757575",
  disabledGray: "#9E9E9E",
  // Deshabilitado sobre fondo oscuro (la app): gris y legible (docs/ui/botones-y-estados.md).
  disabledOnDarkText: "rgba(255,255,255,0.48)",
  disabledOnDarkBorder: "rgba(255,255,255,0.24)",
  disabledOnDarkBg: "rgba(255,255,255,0.1)",
  
  // Divider
  divider: "#EAEAEB",
  
  // Alert colors (opcional, para más adelante)
  error: "#F2B8B5",
  success: "#2E7D32",
  warning: "#ED6C02",
  info: "#0288D1",
  infoBlue: "#125DDB",
};

export const typography = {
  // Font families
  fontFamily: {
    primary: "Inter, sans-serif",
    heading: "Inter, sans-serif",
    mono: "monospace",
  },
  
  // Font sizes
  fontSize: {
    xs: "12px",   // Labels, footer, small text
    sm: "14px",   // Input text, buttons
    md: "22px",   // H1, main headings
    lg: "24px",   // Extra large headings
  },
  
  // Font weights
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  // Line heights
  lineHeight: {
    tight: "16px",
    normal: "20px",
    relaxed: "24px",
  },
  
  // Letter spacing
  letterSpacing: {
    tight: "-0.03em",
    normal: "0em",
    wide: "0.02em",
  },
};

export const spacing = {
  // Border radius
  borderRadius: {
    sm: "4px",
    md: "8px",
    lg: "16px",
    xl: "24px",
  },
  
  // Margins y Paddings
  unit: 8, // Base unit (8px)
  
  // Spacing scale (basado en 8px)
  xs: "8px",   // 1 unit
  sm: "16px",  // 2 units
  md: "24px",  // 3 units
  lg: "32px",  // 4 units
  xl: "48px",  // 6 units
};

export const shadows = {
  card: "0 4px 12px rgba(0,0,0,0.1)",
  overlay: "0 8px 24px rgba(0,0,0,0.15)",
};

export const zIndex = {
  background: 0,
  content: 1,
  logo: 10,
  card: 20,
  overlay: 100,
  modal: 1000,
};

export const layout = {
  mapHeaderHeight: 64,
  /** Ancho del rail lateral (MapHeader + offset de paneles) */
  sidebarRailWidth: 68,
  /** Separación entre sidebar y panel lateral en desktop */
  mapPanelLeftGap: 25,
  /** Inset superior de paneles laterales (alinea con el rail del sidebar) */
  mapPanelTopInset: 24,
  sidebarItemHeight: 40,
  sidebarIconSize: 24,
};

// Export todo junto como default
const theme = {
  colors,
  typography,
  spacing,
  shadows,
  zIndex,
  layout,
};

export default theme;